import { ReactComponent as FlagIcon } from "./svg/ph-flag.svg";
import "../flag-icon.scss";

export const PHFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
